import { withEnumBadge } from "@/components/EnumBadge.tsx";
import { statusDescriptions } from "@/modules/metal/status/StatusLabels.tsx";

export const MetalStatusBadge = withEnumBadge(statusDescriptions);
